// Company Registration Form JavaScript

let currentStep = 1;
const totalSteps = 6;
let signatureCanvas, signatureContext;
let isDrawing = false;

// Form data storage
let formData = {
    directors: [],
    shareholding: [],
    trustDetails: null
};

// Initialize form when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    initializeForm();
    initializeSignatureCanvas();
    initializeSignatureDate();
    setupEventListeners();
    initializeBalloonPopups();
});

function initializeForm() {
    // Set up number of directors change handler
    const numberOfDirectorsSelect = document.getElementById('numberOfDirectors');
    numberOfDirectorsSelect.addEventListener('change', handleDirectorsCountChange);
    
    // Initialize step navigation
    updateStepDisplay();
    updateNavigationButtons();
}

function setupEventListeners() {
    // Trust type change handler
    const trustTypeSelect = document.getElementById('trustType');
    if (trustTypeSelect) {
        trustTypeSelect.addEventListener('change', handleTrustTypeChange);
    }

    // Form submission
    const form = document.getElementById('companyRegistrationForm');
    form.noValidate = true;
    form.addEventListener('submit', handleFormSubmission);

    // Step navigation buttons
    document.querySelectorAll('.step-nav-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const targetStep = parseInt(this.dataset.step);
            const maxStep = getMaxAccessibleStep();

            // Block navigation to step 3 when it is skipped
            if (targetStep === 3 && shouldSkipShareholdingStep()) {
                return;
            }

            if (targetStep <= maxStep) {
                goToStep(targetStep);
            } else {
                // Show helpful message for disabled steps
                let message = '';
                if (targetStep === 2 && maxStep < 2) {
                    message = 'Please complete the company details first.';
                } else if (targetStep === 3 && maxStep < 3) {
                    message = 'Please complete the directors information first.';
                } else if (targetStep === 4 && maxStep < 4) {
                    message = 'Please complete the shareholding structure first.';
                } else if (targetStep === 5 && maxStep < 5) {
                    message = 'Please complete the registration details first.';
                }
                
                if (message) {
                    alert(message);
                }
            }
        });
    });
}

function handleDirectorsCountChange() {
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    if (numberOfDirectors > 0) {
        generateDirectorFields(numberOfDirectors);
    }
}

function generateDirectorFields(numberOfDirectors) {
    const container = document.getElementById('directorsContainer');
    container.innerHTML = '';
    
    // Reset directors data
    formData.directors = [];
    
    for (let i = 1; i <= numberOfDirectors; i++) {
        const directorDiv = createDirectorFields(i);
        container.appendChild(directorDiv);
        
        // Initialize director data
        formData.directors.push({
            id: i,
            isShareholder: false,
            shareDetails: null
        });
    }
    
    // Clear any existing shareholding structure if we're already on step 3
    if (currentStep >= 3) {
        updateShareholdingStructure();
    }

    // Refresh nav buttons in case the skip condition changed
    updateStepNavigationButtons();

    // Set up balloon popups for the newly created director fields
    setTimeout(() => {
        setupDynamicBalloonPopups();
    }, 100);
}

function createDirectorFields(directorNumber) {
    const directorDiv = document.createElement('div');
    directorDiv.className = 'director-card';
    directorDiv.innerHTML = `
        <h3>Director ${directorNumber}</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label for="director${directorNumber}FirstName" class="block text-sm font-medium text-gray-700 mb-1">First name <span class="text-red-500">*</span></label>
                <input type="text" id="director${directorNumber}FirstName" name="director${directorNumber}FirstName" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}MiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                <input type="text" id="director${directorNumber}MiddleName" name="director${directorNumber}MiddleName"
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}LastName" class="block text-sm font-medium text-gray-700 mb-1">Last name <span class="text-red-500">*</span></label>
                <input type="text" id="director${directorNumber}LastName" name="director${directorNumber}LastName" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}Email" class="block text-sm font-medium text-gray-700 mb-1">Email <span class="text-red-500">*</span></label>
                <input type="email" id="director${directorNumber}Email" name="director${directorNumber}Email" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}Telephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone <span class="text-red-500">*</span></label>
                <input type="tel" id="director${directorNumber}Telephone" name="director${directorNumber}Telephone" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}DateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth <span class="text-red-500">*</span></label>
                <input type="date" id="director${directorNumber}DateOfBirth" name="director${directorNumber}DateOfBirth" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}CityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">City or suburb of birth <span class="text-red-500">*</span></label>
                <input type="text" id="director${directorNumber}CityOfBirth" name="director${directorNumber}CityOfBirth" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}CountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Country of birth <span class="text-red-500">*</span></label>
                <input type="text" id="director${directorNumber}CountryOfBirth" name="director${directorNumber}CountryOfBirth" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}TFN" class="block text-sm font-medium text-gray-700 mb-1">Personal Tax File Number (TFN) <span class="text-red-500">*</span></label>
                <input type="text" id="director${directorNumber}TFN" name="director${directorNumber}TFN" required
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorNumber}DIN" class="block text-sm font-medium text-gray-700 mb-1">
                    <div class="relative inline-block">
                        Directors Identification Number (DIN) 
                        <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" 
                           data-popup-target="dinInfo${directorNumber}"></i>
                        
                        <!-- Balloon Popup -->
                        <div id="dinInfo${directorNumber}" 
                             class="dependents-popup dependents-popup-arrow-left absolute left-6 top-1/2 transform -translate-y-1/2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                             style="display: none;">
                            
                            <!-- Popup Header -->
                            <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                <i class="fas fa-exclamation-triangle text-gold-600 mr-2"></i>
                                <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                            </div>
                            
                            <!-- Popup Content -->
                            <div class="text-sm text-gray-700 leading-relaxed">
                                <p>
                                    ASIC requires directors appointed before 1 November 2021 to apply for a directors identification number (DIN) by 30 November 2022. New directors appointed to a company between 1 November 2021 and 4 April 2022 need to apply for DIN within 28 days from their appointment and finally from 5 April 2022 any new director intending to be appointed as director must hold DIN before being appointed.<br>
                                    Penalties: The Australian Securities and Investments Commission (ASIC) can enforce the maximum penalty for an offence against section 1272C(1) of the Corporations Act 2001 equal to 60 penalty units which equate to $13,320. <br>
                                    To apply for DIN <a href="https://www.abrs.gov.au/director-identification-number/apply-director-identification-number" class="text-gold-600 underline">click here</a>. Follow the three-step process, once you finalise your application, you will immediately be issued with DIN
                                </p>
                            </div>
                            
                            <!-- Close hint -->
                            <div class="mt-3 pt-2 border-t border-gold-100">
                                <p class="text-xs text-gray-500 italic">
                                    <span class="hidden md:inline">
                                        <i class="fas fa-mouse-pointer mr-1"></i>
                                        Move cursor away to close
                                    </span>
                                    <span class="md:hidden">
                                        <i class="fas fa-hand-pointer mr-1"></i>
                                        Tap outside or press × to close
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </label>
                <input type="text" id="director${directorNumber}DIN" name="director${directorNumber}DIN"
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
        </div>
        
        <!-- Shareholder Question -->
        <div class="mt-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">Is this director going to be a shareholder?</label>
            <div class="flex space-x-4">
                <label class="flex items-center">
                    <input type="radio" name="director${directorNumber}IsShareholder" value="yes" 
                           onchange="handleShareholderChange(${directorNumber}, true)"
                           class="mr-2 h-4 w-4 text-gold-600 focus:ring-gold-500 border-gray-300">
                    Yes
                </label>
                <label class="flex items-center">
                    <input type="radio" name="director${directorNumber}IsShareholder" value="no" 
                           onchange="handleShareholderChange(${directorNumber}, false)"
                           class="mr-2 h-4 w-4 text-gold-600 focus:ring-gold-500 border-gray-300">
                    No
                </label>
            </div>
        </div>
        
        <!-- Nominee Checkbox (shown when Yes is selected) -->
        <div id="director${directorNumber}NomineeSection" class="mt-4" style="display: none;">
            <label class="flex items-start space-x-3">
                <input type="checkbox" id="director${directorNumber}Nominee" name="director${directorNumber}Nominee"
                       class="mt-1 h-4 w-4 text-gold-600 focus:ring-gold-500 border-gray-300 rounded">
                <span class="text-sm font-medium text-gray-700">
                    ✓ I nominate myself to hold shares in the proposed entity for registration
                </span>
            </label>
        </div>
        
        <!-- Nominee Type Dropdown (shown when No is selected) -->
        <div id="director${directorNumber}NomineeTypeSection" class="mt-4" style="display: none;">
            <label for="director${directorNumber}NomineeType" class="block text-sm font-medium text-gray-700 mb-2">
                <div class="relative inline-block">
                    Who will hold shares for this officeholder? 
                    <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" 
                       data-popup-target="nomineeShareholderPopup${directorNumber}"></i>
                    
                    <!-- Standard Info Balloon -->
                    <div id="nomineeShareholderPopup${directorNumber}" 
                         class="dependents-popup dependents-popup-arrow-left absolute left-6 top-1/2 transform -translate-y-1/2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                         style="display: none;">
                        
                        <!-- Popup Header -->
                        <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                            <i class="fas fa-info-circle text-gold-600 mr-2"></i>
                            <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                        </div>
                        
                        <!-- Popup Content -->
                        <div class="text-sm text-gray-700 leading-relaxed">
                            <p>
                                A nominee shareholder is just another person who is nominated by you to hold shares in a private company on your behalf, it's important that you enter into a nominee shareholder agreement and the shares are generally not held beneficially.
                            </p>
                        </div>
                        
                        <!-- Close hint -->
                        <div class="mt-3 pt-2 border-t border-gold-100">
                            <p class="text-xs text-gray-500 italic">
                                <span class="hidden md:inline">
                                    <i class="fas fa-mouse-pointer mr-1"></i>
                                    Move cursor away to close
                                </span>
                                <span class="md:hidden">
                                    <i class="fas fa-hand-pointer mr-1"></i>
                                    Tap outside or press × to close
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </label>
            <select id="director${directorNumber}NomineeType" name="director${directorNumber}NomineeType"
                    onchange="handleNomineeTypeChange(${directorNumber})"
                    class="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                <option value="">Select nominee type...</option>
                <option value="individual">Nominee Individual</option>
                <option value="company">Company</option>
                <option value="trust">Trust</option>
            </select>
        </div>
        
        <!-- Nominee Individual Details (shown when Nominee Individual is selected) -->
        <div id="director${directorNumber}NomineeIndividualSection" class="mt-6" style="display: none;">
            <div class="bg-amber-50 border-l-4 border-amber-400 p-4 mb-4">
                <h4 class="text-md font-semibold text-amber-800 mb-2">Nominee Individual</h4>
                
                <!-- Is nominee also a director question -->
                <div class="mb-4">
                    <label for="director${directorNumber}NomineeIsDirector" class="block text-sm font-medium text-gray-700 mb-2">
                        Is the nominee individual holding the shares also a director?
                    </label>
                    <select id="director${directorNumber}NomineeIsDirector" name="director${directorNumber}NomineeIsDirector"
                            onchange="handleNomineeIsDirectorChange(${directorNumber})"
                            class="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        <option value="">Select...</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                
                <!-- Warning message when Yes is selected -->
                <div id="director${directorNumber}NomineeDirectorWarning" class="mt-4 p-4 bg-yellow-50 border border-yellow-400 rounded-lg" style="display: none;">
                    <div class="flex items-start">
                        <i class="fas fa-exclamation-triangle text-yellow-600 mr-3 mt-1"></i>
                        <p class="text-sm text-yellow-800">
                            <strong>Important:</strong> We do not encourage a director to hold shares for other stakeholders. Ensure that you enter into a shareholder's agreement.
                        </p>
                    </div>
                </div>
                
                <!-- Nominee Individual Details (shown when No is selected) -->
                <div id="director${directorNumber}NomineeIndividualDetails" class="mt-4" style="display: none;">
                    <h5 class="text-md font-semibold text-gray-700 mb-4">
                        Please provide details of the individual who will be holding the shares on behalf of the Office Holder:
                    </h5>
                    
                    <p class="text-sm text-gray-600 mb-4">Please provide the following information:</p>
                    
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label for="director${directorNumber}NomineeFirstName" class="block text-sm font-medium text-gray-700 mb-1">
                                First name <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="director${directorNumber}NomineeFirstName" name="director${directorNumber}NomineeFirstName"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeMiddleName" class="block text-sm font-medium text-gray-700 mb-1">
                                Middle name
                            </label>
                            <input type="text" id="director${directorNumber}NomineeMiddleName" name="director${directorNumber}NomineeMiddleName"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeLastName" class="block text-sm font-medium text-gray-700 mb-1">
                                Last name <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="director${directorNumber}NomineeLastName" name="director${directorNumber}NomineeLastName"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeEmail" class="block text-sm font-medium text-gray-700 mb-1">
                                Email <span class="text-red-500">*</span>
                            </label>
                            <input type="email" id="director${directorNumber}NomineeEmail" name="director${directorNumber}NomineeEmail"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeTelephone" class="block text-sm font-medium text-gray-700 mb-1">
                                Telephone <span class="text-red-500">*</span>
                            </label>
                            <input type="tel" id="director${directorNumber}NomineeTelephone" name="director${directorNumber}NomineeTelephone"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeDateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                Date of birth <span class="text-red-500">*</span>
                            </label>
                            <input type="date" id="director${directorNumber}NomineeDateOfBirth" name="director${directorNumber}NomineeDateOfBirth"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeCityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                City or suburb of birth <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="director${directorNumber}NomineeCityOfBirth" name="director${directorNumber}NomineeCityOfBirth"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeCountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                Country of birth <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="director${directorNumber}NomineeCountryOfBirth" name="director${directorNumber}NomineeCountryOfBirth"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                        
                        <div>
                            <label for="director${directorNumber}NomineeTFN" class="block text-sm font-medium text-gray-700 mb-1">
                                Personal Tax File Number (TFN) <span class="text-red-500">*</span>
                            </label>
                            <input type="text" id="director${directorNumber}NomineeTFN" name="director${directorNumber}NomineeTFN"
                                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        </div>
                    </div>
                    
                    <div class="mt-4">
                        <label for="director${directorNumber}NomineeResidentialAddress" class="block text-sm font-medium text-gray-700 mb-1">
                            Residential address <span class="text-red-500">*</span>
                        </label>
                        <textarea id="director${directorNumber}NomineeResidentialAddress" name="director${directorNumber}NomineeResidentialAddress" rows="3"
                                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"></textarea>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Nominee Company Section -->
        <div id="director${directorNumber}NomineeCompanySection" class="mt-4" style="display: none;">
            <div class="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-md">
                <h4 class="text-md font-semibold text-amber-800 mb-3">Nominee Company Information</h4>
                <p class="text-sm text-gray-700 mb-4">Please provide the following information:</p>
                
                <div class="space-y-4">
                    <div>
                        <label for="director${directorNumber}NomineeCompanyName" class="block text-sm font-medium text-gray-700 mb-1">
                            Please provide the registered name of the legal entity that will hold the share <span class="text-red-500">*</span>
                        </label>
                        <input type="text" id="director${directorNumber}NomineeCompanyName" name="director${directorNumber}NomineeCompanyName"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    </div>
                    
                    <div>
                        <label for="director${directorNumber}NomineeCompanyACN" class="block text-sm font-medium text-gray-700 mb-1">
                            Please provide the Australian Company Number (ACN) <span class="text-red-500">*</span>
                        </label>
                        <input type="text" id="director${directorNumber}NomineeCompanyACN" name="director${directorNumber}NomineeCompanyACN"
                               pattern="[0-9]{9}" maxlength="9"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"
                               placeholder="123456789">
                    </div>
                    
                    <div>
                        <label for="director${directorNumber}NomineeCompanyAddress" class="block text-sm font-medium text-gray-700 mb-1">
                            Please provide the registered office address for the legal entity <span class="text-red-500">*</span>
                        </label>
                        <textarea id="director${directorNumber}NomineeCompanyAddress" name="director${directorNumber}NomineeCompanyAddress" rows="3"
                                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"></textarea>
                    </div>
                    
                    <div>
                        <label for="director${directorNumber}NomineeCompanyTFN" class="block text-sm font-medium text-gray-700 mb-1">
                            The Tax File Number of the legal entity <span class="text-red-500">*</span>
                        </label>
                        <input type="text" id="director${directorNumber}NomineeCompanyTFN" name="director${directorNumber}NomineeCompanyTFN"
                               pattern="[0-9]{9}" maxlength="9"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"
                               placeholder="123456789">
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Nominee Trust Section -->
        <div id="director${directorNumber}NomineeTrustSection" class="mt-4" style="display: none;">
            <div class="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-md">
                <h4 class="text-md font-semibold text-amber-800 mb-3">Nominee Trust Information</h4>
                <p class="text-sm text-gray-700 mb-4">Please provide the following information:</p>
                
                <div class="space-y-4">
                    <div>
                        <label for="director${directorNumber}NomineeTrustName" class="block text-sm font-medium text-gray-700 mb-1">
                            What is the Trust Name? <span class="text-red-500">*</span>
                        </label>
                        <input type="text" id="director${directorNumber}NomineeTrustName" name="director${directorNumber}NomineeTrustName"
                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    </div>
                    
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Trustee Details</label>
                        <label for="director${directorNumber}NomineeTrusteeType" class="block text-sm font-medium text-gray-700 mb-1">
                            Is the Trustee an individual or corporate? <span class="text-red-500">*</span>
                        </label>
                        <select id="director${directorNumber}NomineeTrusteeType" name="director${directorNumber}NomineeTrusteeType"
                                onchange="handleNomineeTrusteeTypeChange(${directorNumber})"
                                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            <option value="">-- Please select --</option>
                            <option value="individual">Individual</option>
                            <option value="company">Company</option>
                        </select>
                    </div>
                    
                    <!-- Individual Trustee Fields -->
                    <div id="director${directorNumber}NomineeTrusteeIndividual" style="display: none;">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeFirstName" class="block text-sm font-medium text-gray-700 mb-1">
                                    First name <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeFirstName" name="director${directorNumber}NomineeTrusteeFirstName"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeMiddleName" class="block text-sm font-medium text-gray-700 mb-1">
                                    Middle name
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeMiddleName" name="director${directorNumber}NomineeTrusteeMiddleName"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeLastName" class="block text-sm font-medium text-gray-700 mb-1">
                                    Last name <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeLastName" name="director${directorNumber}NomineeTrusteeLastName"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeEmail" class="block text-sm font-medium text-gray-700 mb-1">
                                    Email <span class="text-red-500">*</span>
                                </label>
                                <input type="email" id="director${directorNumber}NomineeTrusteeEmail" name="director${directorNumber}NomineeTrusteeEmail"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeTelephone" class="block text-sm font-medium text-gray-700 mb-1">
                                    Telephone <span class="text-red-500">*</span>
                                </label>
                                <input type="tel" id="director${directorNumber}NomineeTrusteeTelephone" name="director${directorNumber}NomineeTrusteeTelephone"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeDateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                    Date of birth <span class="text-red-500">*</span>
                                </label>
                                <input type="date" id="director${directorNumber}NomineeTrusteeDateOfBirth" name="director${directorNumber}NomineeTrusteeDateOfBirth"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeCityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                    City or suburb of birth <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeCityOfBirth" name="director${directorNumber}NomineeTrusteeCityOfBirth"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeCountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">
                                    Country of birth <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeCountryOfBirth" name="director${directorNumber}NomineeTrusteeCountryOfBirth"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeTFN" class="block text-sm font-medium text-gray-700 mb-1">
                                    Personal Tax File Number (TFN) <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeTFN" name="director${directorNumber}NomineeTrusteeTFN"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                        </div>
                        
                        <div class="mt-4">
                            <label for="director${directorNumber}NomineeTrusteeResidentialAddress" class="block text-sm font-medium text-gray-700 mb-1">
                                Residential address <span class="text-red-500">*</span>
                            </label>
                            <textarea id="director${directorNumber}NomineeTrusteeResidentialAddress" name="director${directorNumber}NomineeTrusteeResidentialAddress" rows="3"
                                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"></textarea>
                        </div>
                    </div>
                    
                    <!-- Corporate Trustee Fields -->
                    <div id="director${directorNumber}NomineeTrusteeCompany" style="display: none;">
                        <div class="space-y-4 mt-4">
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeCompanyName" class="block text-sm font-medium text-gray-700 mb-1">
                                    Please provide the registered name of the legal entity that will hold the share <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeCompanyName" name="director${directorNumber}NomineeTrusteeCompanyName"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeCompanyACN" class="block text-sm font-medium text-gray-700 mb-1">
                                    Please provide the Australian Company Number (ACN) <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="director${directorNumber}NomineeTrusteeCompanyACN" name="director${directorNumber}NomineeTrusteeCompanyACN"
                                       pattern="[0-9]{9}" maxlength="9"
                                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"
                                       placeholder="123456789">
                            </div>
                            
                            <div>
                                <label for="director${directorNumber}NomineeTrusteeCompanyAddress" class="block text-sm font-medium text-gray-700 mb-1">
                                    Please provide the registered office address for the legal entity <span class="text-red-500">*</span>
                                </label>
                                <textarea id="director${directorNumber}NomineeTrusteeCompanyAddress" name="director${directorNumber}NomineeTrusteeCompanyAddress" rows="3"
                                          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    return directorDiv;
}

function handleShareholderChange(directorNumber, isShareholder) {
    const nomineeSection = document.getElementById(`director${directorNumber}NomineeSection`);
    const nomineeTypeSection = document.getElementById(`director${directorNumber}NomineeTypeSection`);
    
    if (isShareholder) {
        nomineeSection.style.display = 'block';
        nomineeTypeSection.style.display = 'none';
        
        // Clear all nominee fields and hide sections when switching to direct shareholder
        clearNomineeFields(directorNumber);
        
        formData.directors[directorNumber - 1].isShareholder = true;
        formData.directors[directorNumber - 1].nomineeType = null;
    } else {
        nomineeSection.style.display = 'none';
        nomineeTypeSection.style.display = 'block';
        formData.directors[directorNumber - 1].isShareholder = false;
        formData.directors[directorNumber - 1].shareDetails = null;
    }
    
    // If currently on step 3 and the skip condition just became active, go back to step 2
    if (currentStep === 3 && shouldSkipShareholdingStep()) {
        goToStep(2);
        return;
    }

    // Update shareholding structure immediately if on step 3 or later
    if (currentStep >= 3) {
        updateShareholdingStructure();
    }

    // Refresh nav buttons so step 3 skipped state reflects immediately
    updateStepNavigationButtons();
}

function shouldSkipShareholdingStep() {
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    if (numberOfDirectors !== 1) return false;
    const noRadio = document.querySelector('input[name="director1IsShareholder"][value="no"]');
    return noRadio && noRadio.checked;
}

function clearNomineeFields(directorNumber) {
    // Hide all nominee type sections
    const nomineeIndividualSection = document.getElementById(`director${directorNumber}NomineeIndividualSection`);
    const nomineeCompanySection = document.getElementById(`director${directorNumber}NomineeCompanySection`);
    const nomineeTrustSection = document.getElementById(`director${directorNumber}NomineeTrustSection`);
    
    if (nomineeIndividualSection) nomineeIndividualSection.style.display = 'none';
    if (nomineeCompanySection) nomineeCompanySection.style.display = 'none';
    if (nomineeTrustSection) nomineeTrustSection.style.display = 'none';
    
    // Clear all required states
    setNomineeIndividualFieldsRequired(directorNumber, false);
    setNomineeCompanyFieldsRequired(directorNumber, false);
    setNomineeTrustFieldsRequired(directorNumber, false);
    setNomineeTrusteeIndividualFieldsRequired(directorNumber, false);
    setNomineeTrusteeCompanyFieldsRequired(directorNumber, false);
    
    // Reset nominee type dropdown
    const nomineeTypeSelect = document.getElementById(`director${directorNumber}NomineeType`);
    if (nomineeTypeSelect) nomineeTypeSelect.value = '';
    
    // Clear Individual Nominee fields
    clearInputValue(`director${directorNumber}NomineeIsDirector`);
    clearInputValue(`director${directorNumber}NomineeFirstName`);
    clearInputValue(`director${directorNumber}NomineeMiddleName`);
    clearInputValue(`director${directorNumber}NomineeLastName`);
    clearInputValue(`director${directorNumber}NomineeEmail`);
    clearInputValue(`director${directorNumber}NomineeTelephone`);
    clearInputValue(`director${directorNumber}NomineeDateOfBirth`);
    clearInputValue(`director${directorNumber}NomineeCityOfBirth`);
    clearInputValue(`director${directorNumber}NomineeCountryOfBirth`);
    clearInputValue(`director${directorNumber}NomineeTFN`);
    clearInputValue(`director${directorNumber}NomineeAddress`);
    
    // Clear Company Nominee fields
    clearInputValue(`director${directorNumber}NomineeCompanyName`);
    clearInputValue(`director${directorNumber}NomineeCompanyACN`);
    clearInputValue(`director${directorNumber}NomineeCompanyAddress`);
    clearInputValue(`director${directorNumber}NomineeCompanyTFN`);
    
    // Clear Trust Nominee fields
    clearInputValue(`director${directorNumber}NomineeTrustName`);
    clearInputValue(`director${directorNumber}NomineeTrusteeType`);
    
    // Clear Individual Trustee fields
    clearInputValue(`director${directorNumber}NomineeTrusteeFirstName`);
    clearInputValue(`director${directorNumber}NomineeTrusteeMiddleName`);
    clearInputValue(`director${directorNumber}NomineeTrusteeLastName`);
    clearInputValue(`director${directorNumber}NomineeTrusteeEmail`);
    clearInputValue(`director${directorNumber}NomineeTrusteeTelephone`);
    clearInputValue(`director${directorNumber}NomineeTrusteeDateOfBirth`);
    clearInputValue(`director${directorNumber}NomineeTrusteeCityOfBirth`);
    clearInputValue(`director${directorNumber}NomineeTrusteeCountryOfBirth`);
    
    // Clear Company Trustee fields
    clearInputValue(`director${directorNumber}NomineeTrusteeCompanyName`);
    clearInputValue(`director${directorNumber}NomineeTrusteeCompanyACN`);
    
    // Hide nested sections
    const nomineeIndividualDetails = document.getElementById(`director${directorNumber}NomineeIndividualDetails`);
    const trusteeIndividualSection = document.getElementById(`director${directorNumber}NomineeTrusteeIndividual`);
    const trusteeCompanySection = document.getElementById(`director${directorNumber}NomineeTrusteeCompany`);
    const nomineeDirectorWarning = document.getElementById(`director${directorNumber}NomineeDirectorWarning`);
    
    if (nomineeIndividualDetails) nomineeIndividualDetails.style.display = 'none';
    if (trusteeIndividualSection) trusteeIndividualSection.style.display = 'none';
    if (trusteeCompanySection) trusteeCompanySection.style.display = 'none';
    if (nomineeDirectorWarning) nomineeDirectorWarning.style.display = 'none';
}

function clearInputValue(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        if (element.tagName === 'SELECT') {
            element.value = '';
        } else if (element.type === 'checkbox' || element.type === 'radio') {
            element.checked = false;
        } else {
            element.value = '';
        }
    }
}

function handleNomineeTypeChange(directorNumber) {
    const nomineeType = document.getElementById(`director${directorNumber}NomineeType`).value;
    const nomineeIndividualSection = document.getElementById(`director${directorNumber}NomineeIndividualSection`);
    const nomineeCompanySection = document.getElementById(`director${directorNumber}NomineeCompanySection`);
    const nomineeTrustSection = document.getElementById(`director${directorNumber}NomineeTrustSection`);
    
    // Hide all nominee type sections first and clear required states
    nomineeIndividualSection.style.display = 'none';
    nomineeCompanySection.style.display = 'none';
    nomineeTrustSection.style.display = 'none';
    
    // Clear all required states first
    setNomineeIndividualFieldsRequired(directorNumber, false);
    setNomineeCompanyFieldsRequired(directorNumber, false);
    setNomineeTrustFieldsRequired(directorNumber, false);
    
    // Also clear nested trustee required states
    setNomineeTrusteeIndividualFieldsRequired(directorNumber, false);
    setNomineeTrusteeCompanyFieldsRequired(directorNumber, false);
    
    // Show appropriate section based on selection and set required
    if (nomineeType === 'individual') {
        nomineeIndividualSection.style.display = 'block';
        // Individual fields are set to required in handleNomineeIsDirectorChange
    } else if (nomineeType === 'company') {
        nomineeCompanySection.style.display = 'block';
        setNomineeCompanyFieldsRequired(directorNumber, true);
    } else if (nomineeType === 'trust') {
        nomineeTrustSection.style.display = 'block';
        setNomineeTrustFieldsRequired(directorNumber, true);
    }
    
    // Update formData
    if (formData.directors[directorNumber - 1]) {
        formData.directors[directorNumber - 1].nomineeType = nomineeType;
    }
}

function handleNomineeTrusteeTypeChange(directorNumber) {
    const trusteeType = document.getElementById(`director${directorNumber}NomineeTrusteeType`).value;
    const trusteeIndividualSection = document.getElementById(`director${directorNumber}NomineeTrusteeIndividual`);
    const trusteeCompanySection = document.getElementById(`director${directorNumber}NomineeTrusteeCompany`);
    
    // Hide all trustee type sections first
    trusteeIndividualSection.style.display = 'none';
    trusteeCompanySection.style.display = 'none';
    
    // Show appropriate section based on selection
    if (trusteeType === 'individual') {
        trusteeIndividualSection.style.display = 'block';
        setNomineeTrusteeIndividualFieldsRequired(directorNumber, true);
        setNomineeTrusteeCompanyFieldsRequired(directorNumber, false);
    } else if (trusteeType === 'company') {
        trusteeCompanySection.style.display = 'block';
        setNomineeTrusteeIndividualFieldsRequired(directorNumber, false);
        setNomineeTrusteeCompanyFieldsRequired(directorNumber, true);
    } else {
        setNomineeTrusteeIndividualFieldsRequired(directorNumber, false);
        setNomineeTrusteeCompanyFieldsRequired(directorNumber, false);
    }
}

function setNomineeTrusteeIndividualFieldsRequired(directorNumber, isRequired) {
    const fields = [
        `director${directorNumber}NomineeTrusteeFirstName`,
        `director${directorNumber}NomineeTrusteeLastName`,
        `director${directorNumber}NomineeTrusteeEmail`,
        `director${directorNumber}NomineeTrusteeTelephone`,
        `director${directorNumber}NomineeTrusteeDateOfBirth`,
        `director${directorNumber}NomineeTrusteeCityOfBirth`,
        `director${directorNumber}NomineeTrusteeCountryOfBirth`,
        `director${directorNumber}NomineeTrusteeTFN`,
        `director${directorNumber}NomineeTrusteeResidentialAddress`
    ];
    
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.required = isRequired;
        }
    });
}

function setNomineeTrusteeCompanyFieldsRequired(directorNumber, isRequired) {
    const fields = [
        `director${directorNumber}NomineeTrusteeCompanyName`,
        `director${directorNumber}NomineeTrusteeCompanyACN`,
        `director${directorNumber}NomineeTrusteeCompanyAddress`
    ];
    
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.required = isRequired;
        }
    });
}

function handleNomineeIsDirectorChange(directorNumber) {
    const isDirector = document.getElementById(`director${directorNumber}NomineeIsDirector`).value;
    const warningSection = document.getElementById(`director${directorNumber}NomineeDirectorWarning`);
    const detailsSection = document.getElementById(`director${directorNumber}NomineeIndividualDetails`);
    
    if (isDirector === 'yes') {
        warningSection.style.display = 'block';
        detailsSection.style.display = 'none';
        // Clear required state for detail fields
        setNomineeIndividualFieldsRequired(directorNumber, false);
    } else if (isDirector === 'no') {
        warningSection.style.display = 'none';
        detailsSection.style.display = 'block';
        // Set required state for detail fields
        setNomineeIndividualFieldsRequired(directorNumber, true);
    } else {
        warningSection.style.display = 'none';
        detailsSection.style.display = 'none';
        setNomineeIndividualFieldsRequired(directorNumber, false);
    }
}

function setNomineeIndividualFieldsRequired(directorNumber, isRequired) {
    const fields = [
        `director${directorNumber}NomineeFirstName`,
        `director${directorNumber}NomineeLastName`,
        `director${directorNumber}NomineeEmail`,
        `director${directorNumber}NomineeTelephone`,
        `director${directorNumber}NomineeDateOfBirth`,
        `director${directorNumber}NomineeCityOfBirth`,
        `director${directorNumber}NomineeCountryOfBirth`,
        `director${directorNumber}NomineeTFN`,
        `director${directorNumber}NomineeResidentialAddress`
    ];
    
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.required = isRequired;
        }
    });
}

function setNomineeCompanyFieldsRequired(directorNumber, isRequired) {
    const fields = [
        `director${directorNumber}NomineeCompanyName`,
        `director${directorNumber}NomineeCompanyACN`,
        `director${directorNumber}NomineeCompanyAddress`,
        `director${directorNumber}NomineeCompanyTFN`
    ];
    
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.required = isRequired;
        }
    });
}

function setNomineeTrustFieldsRequired(directorNumber, isRequired) {
    const fields = [
        `director${directorNumber}NomineeTrustName`,
        `director${directorNumber}NomineeTrusteeType`
    ];
    
    fields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.required = isRequired;
        }
    });
}

function updateShareholdingStructure() {
    const container = document.getElementById('shareholdingContainer');
    container.innerHTML = '';
    
    // Get the number of directors
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    
    // ALWAYS create shareholding for EACH director (regardless of shareholder status)
    for (let i = 1; i <= numberOfDirectors; i++) {
        const directorName = getDirectorName(i);
        const isDesignatedShareholder = checkIfDirectorIsShareholder(i);
        
        // Create shareholding section for this director
        const shareDiv = createShareAllocationFields(i, directorName, isDesignatedShareholder);
        container.appendChild(shareDiv);
        
        // Update formData
        if (formData.directors[i - 1]) {
            formData.directors[i - 1].isShareholder = isDesignatedShareholder;
        }
    }
    
    // Initialize balloon popups for the newly created shareholding fields
    setTimeout(() => {
        setupDynamicBalloonPopups();
    }, 100);
}

// Helper function to check if director selected "Yes" to being a shareholder
function checkIfDirectorIsShareholder(directorId) {
    const isShareholderYes = document.querySelector(`input[name="director${directorId}IsShareholder"][value="yes"]`);
    return isShareholderYes && isShareholderYes.checked;
}

// Helper to check if director has nominee information
function hasNomineeInfo(directorId) {
    const nomineeType = document.getElementById(`director${directorId}NomineeType`)?.value;
    return nomineeType && nomineeType !== '';
}

// Helper function to get full share class name
function getShareClassName(classCode) {
    const shareClasses = {
        'ORD': 'ORD (Ordinary) Shares',
        'PRF': 'PRF (Preference) Shares',
        'RED': 'RED (Redeemable) Shares',
        'SPE': 'SPE (Special) Shares',
        'A': 'A Shares',
        'B': 'B Shares',
        'EMP': 'EMP (Employee) Shares',
        'FOU': 'FOU (Founder\'s) Shares',
        'LG': 'LG (Life Governor\'s) Shares',
        'MAN': 'MAN (Management) Shares',
        'CUMP': 'CUMP (Cumulative Preference) Shares',
        'NCP': 'NCP (Non-Cumulative Preference) Shares',
        'REDO': 'REDO (Redeemable Preference) Shares',
        'NRP': 'NRP (Non-Redeemable Preference) Shares',
        'CRP': 'CRP (Cumulative Redeemable Preference) Shares',
        'NCRP': 'NCRP (Non-Cumulative Redeemable Preference) Shares',
        'PARP': 'PARP (Participative Preference) Shares'
    };
    return shareClasses[classCode] || classCode;
}

function getDirectorName(directorId) {
    const firstName = document.getElementById(`director${directorId}FirstName`).value || 'Director';
    const lastName = document.getElementById(`director${directorId}LastName`).value || directorId.toString();
    return `${firstName} ${lastName}`;
}

function createShareAllocationFields(directorId, directorName, isDesignatedShareholder) {
    const shareDiv = document.createElement('div');
    shareDiv.className = 'share-allocation';
    
    // Add visual indicator if director is NOT designated as shareholder
    const statusBadge = !isDesignatedShareholder ? `
        <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-300">
            <i class="fas fa-info-circle mr-1"></i>
            Not designated as shareholder in Step 2
        </span>
    ` : `
        <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-300">
            <i class="fas fa-check-circle mr-1"></i>
            Designated as shareholder
        </span>
    `;
    
    shareDiv.innerHTML = `
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3 gap-2">
            <h4 class="font-semibold text-gray-800">Share Allocation - ${directorName}</h4>
            ${statusBadge}
        </div>
        
        <!-- Class of Share Dropdown -->
        <div class="mb-4">
            <label for="director${directorId}ShareClass" class="block text-sm font-medium text-gray-700 mb-1">
                <div class="relative inline-block">
                    Class of Share
                    <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" 
                       data-popup-target="shareClassInfoPopup${directorId}"></i>
                    
                    <!-- Info Balloon Popup -->
                    <div id="shareClassInfoPopup${directorId}" 
                         class="dependents-popup dependents-popup-arrow-left absolute left-6 top-1/2 transform -translate-y-1/2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                         style="display: none;">
                        
                        <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                            <i class="fas fa-info-circle text-gold-600 mr-2"></i>
                            <h4 class="font-semibold text-gray-800 text-sm">Share Classes</h4>
                        </div>
                        
                        <div class="text-sm text-gray-700 leading-relaxed">
                            <p class="mb-2">
                                <strong>Ordinary (ORD) Shares</strong> are the most common type, providing voting rights and dividend participation.
                            </p>
                            <p>
                                Other share classes offer different rights regarding dividends, voting, redemption, or preferential treatment. Select the appropriate class based on your company structure.
                            </p>
                        </div>
                        
                        <div class="mt-3 pt-2 border-t border-gold-100">
                            <p class="text-xs text-gray-500 italic">
                                <span class="hidden md:inline">
                                    <i class="fas fa-mouse-pointer mr-1"></i>
                                    Move cursor away to close
                                </span>
                                <span class="md:hidden">
                                    <i class="fas fa-hand-pointer mr-1"></i>
                                    Tap outside or press × to close
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </label>
            <select id="director${directorId}ShareClass" 
                    name="director${directorId}ShareClass"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400 bg-white">
                <option value="ORD" selected>ORD* (Ordinary) Shares</option>
                <option value="PRF">PRF (Preference) Shares</option>
                <option value="RED">RED (Redeemable) Shares</option>
                <option value="SPE">SPE (Special) Shares</option>
                <option value="A">A Shares</option>
                <option value="B">B Shares</option>
                <option value="EMP">EMP (Employee) Shares</option>
                <option value="FOU">FOU (Founder's) Shares</option>
                <option value="LG">LG (Life Governor's) Shares</option>
                <option value="MAN">MAN (Management) Shares</option>
                <option value="CUMP">CUMP (Cumulative Preference) Shares</option>
                <option value="NCP">NCP (Non-Cumulative Preference) Shares</option>
                <option value="REDO">REDO (Redeemable Preference) Shares</option>
                <option value="NRP">NRP (Non-Redeemable Preference) Shares</option>
                <option value="CRP">CRP (Cumulative Redeemable Preference) Shares</option>
                <option value="NCRP">NCRP (Non-Cumulative Redeemable Preference) Shares</option>
                <option value="PARP">PARP (Participative Preference) Shares</option>
            </select>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
                <label for="director${directorId}SharesNumber" class="block text-sm font-medium text-gray-700 mb-1">
                    <div class="relative inline-block">
                        Number of shares 
                        <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" 
                           data-popup-target="sharesInfoPopup${directorId}"></i>
                        
                        <!-- Balloon Popup -->
                        <div id="sharesInfoPopup${directorId}" 
                             class="dependents-popup dependents-popup-arrow-left absolute left-6 top-1/2 transform -translate-y-1/2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                             style="display: none;">
                            
                            <!-- Popup Header -->
                            <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                <i class="fas fa-info-circle text-gold-600 mr-2"></i>
                                <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                            </div>
                            
                            <!-- Popup Content -->
                            <div class="text-sm text-gray-700 leading-relaxed">
                                <p>
                                    Generally you can issue shares at $1 fully paid shares beneficially held, for example, if there are three (3) directors, you can issue 50 shares per stakeholder fully paid at $1 per share and depending on the purpose of the entity, they may be beneficially held.
                                </p>
                            </div>
                            
                            <!-- Close hint -->
                            <div class="mt-3 pt-2 border-t border-gold-100">
                                <p class="text-xs text-gray-500 italic">
                                    <span class="hidden md:inline">
                                        <i class="fas fa-mouse-pointer mr-1"></i>
                                        Move cursor away to close
                                    </span>
                                    <span class="md:hidden">
                                        <i class="fas fa-hand-pointer mr-1"></i>
                                        Tap outside or press × to close
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </label>
                <input type="number" 
                       id="director${directorId}SharesNumber" 
                       name="director${directorId}SharesNumber" 
                       min="0"
                       value="${isDesignatedShareholder ? '' : '0'}"
                       placeholder="${isDesignatedShareholder ? 'Enter number of shares' : '0 (not a shareholder)'}"
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="director${directorId}ShareValue" class="block text-sm font-medium text-gray-700 mb-1">Value per share ($)</label>
                <input type="number" 
                       id="director${directorId}ShareValue" 
                       name="director${directorId}ShareValue" 
                       min="0" 
                       step="0.01"
                       value="${isDesignatedShareholder ? '' : '0'}"
                       placeholder="${isDesignatedShareholder ? 'Enter value' : '0.00'}"
                       class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div class="flex items-end">
                <label class="flex items-center">
                    <input type="checkbox" 
                           id="director${directorId}BeneficiallyHeld" 
                           name="director${directorId}BeneficiallyHeld"
                           ${isDesignatedShareholder ? '' : 'disabled'}
                           class="mr-2 h-4 w-4 text-gold-600 focus:ring-gold-500 border-gray-300 rounded">
                    <span class="text-sm font-medium text-gray-700">
                        <div class="relative inline-block">
                            Beneficially held 
                            <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" 
                               data-popup-target="beneficiallyHeldPopup${directorId}"></i>
                            
                            <!-- Standard Info Balloon -->
                            <div id="beneficiallyHeldPopup${directorId}" 
                                 class="dependents-popup dependents-popup-arrow-left absolute left-6 top-1/2 transform -translate-y-1/2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                                 style="display: none;">
                                
                                <!-- Popup Header -->
                                <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                    <i class="fas fa-info-circle text-gold-600 mr-2"></i>
                                    <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                                </div>
                                
                                <!-- Popup Content -->
                                <div class="text-sm text-gray-700 leading-relaxed">
                                    <p>
                                        Beneficially held shares mean they are held for a direct benefit such as dividend distribution, however, if they are held on behalf of another entity or individual, then they are not beneficially held.
                                    </p>
                                </div>
                                
                                <!-- Close hint -->
                                <div class="mt-3 pt-2 border-t border-gold-100">
                                    <p class="text-xs text-gray-500 italic">
                                        <span class="hidden md:inline">
                                            <i class="fas fa-mouse-pointer mr-1"></i>
                                            Move cursor away to close
                                        </span>
                                        <span class="md:hidden">
                                            <i class="fas fa-hand-pointer mr-1"></i>
                                            Tap outside or press × to close
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </span>
                </label>
            </div>
        </div>
        ${!isDesignatedShareholder ? `
            <div class="mt-3 p-3 bg-gold-50 border border-gold-200 rounded-md">
                <p class="text-sm text-gold-800">
                    <i class="fas fa-lightbulb mr-1"></i>
                    <strong>Note:</strong> This director was marked as "Not a shareholder" in Step 2. 
                    You can still allocate shares here if needed, or leave as 0 shares.
                    ${hasNomineeInfo(directorId) ? ' Nominee/trustee information is captured in Step 2.' : ''}
                </p>
            </div>
        ` : ''}
    `;
    
    return shareDiv;
}

// Step navigation functions
function changeStep(direction) {
    const newStep = currentStep + direction;

    if (direction > 0) {
        // Validate current step before proceeding
        if (!validateCurrentStep()) {
            return;
        }
    }

    // Skip step 3 (shareholding) when 1 director is not a shareholder
    let targetStep = newStep;
    if (shouldSkipShareholdingStep() && newStep === 3) {
        targetStep = direction > 0 ? 4 : 2;
    }

    if (targetStep >= 1 && targetStep <= totalSteps) {
        goToStep(targetStep);
    }
}

function goToStep(stepNumber) {
    // If step 3 should be skipped, redirect to the appropriate adjacent step
    if (stepNumber === 3 && shouldSkipShareholdingStep()) {
        stepNumber = stepNumber > currentStep ? 4 : 2;
    }

    // Hide current step
    document.getElementById(`step-${currentStep}`).classList.remove('active');
    
    // Show new step
    document.getElementById(`step-${stepNumber}`).classList.add('active');
    
    currentStep = stepNumber;
    
    updateStepDisplay();
    updateNavigationButtons();
    
    // Update step navigation buttons
    document.querySelectorAll('.step-nav-btn').forEach(btn => {
        btn.classList.remove('active');
        if (parseInt(btn.dataset.step) === currentStep) {
            btn.classList.add('active');
        }
    });
    
    // Special handling for step 3 (shareholding structure)
    if (currentStep === 3) {
        updateShareholdingStructure();
    }
    
    // Special handling for step 4 (registration details)
    if (currentStep === 4) {
        // Initialize balloon popups for registration details
        setTimeout(() => {
            setupDynamicBalloonPopups();
        }, 100);
    }
    
    // Special handling for step 5 (declarations)
    if (currentStep === 5) {
        // Initialize balloon popups for step 5
        setTimeout(() => {
            setupDynamicBalloonPopups();
        }, 100);
    }
    
    // Special handling for step 6 (review)
    if (currentStep === 6) {
        populateReviewSection();
        // Initialize balloon popups for step 6
        setTimeout(() => {
            setupDynamicBalloonPopups();
        }, 100);
    }
}

function updateStepDisplay() {
    document.getElementById('progressText').textContent = `Step ${currentStep} of ${totalSteps}`;
    document.getElementById('stepInfo').textContent = `Step ${currentStep} of ${totalSteps}`;
    
    const progressPercentage = (currentStep / totalSteps) * 100;
    document.getElementById('progressBar').style.width = `${progressPercentage}%`;
    
    // Update step navigation buttons
    updateStepNavigationButtons();
}

function updateStepNavigationButtons() {
    const maxAccessibleStep = getMaxAccessibleStep();
    const skipStep3 = shouldSkipShareholdingStep();

    document.querySelectorAll('.step-nav-btn').forEach((btn, index) => {
        const stepNumber = index + 1;

        // Remove all classes and reset inline styles
        btn.classList.remove('active', 'completed', 'accessible', 'disabled');
        btn.style.cursor = '';
        btn.style.opacity = '';
        btn.style.textDecoration = '';

        // Mark step 3 as skipped when applicable
        if (stepNumber === 3 && skipStep3) {
            btn.classList.add('disabled');
            btn.style.cursor = 'default';
            btn.style.opacity = '0.35';
            btn.style.textDecoration = 'line-through';
            return;
        }

        if (stepNumber === currentStep) {
            // Current step
            btn.classList.add('active');
        } else if (stepNumber < currentStep) {
            // Completed steps
            btn.classList.add('completed');
        } else if (stepNumber <= maxAccessibleStep) {
            // Accessible but not yet visited
            btn.classList.add('accessible');
        } else {
            // Not yet accessible
            btn.classList.add('disabled');
            btn.style.cursor = 'not-allowed';
            btn.style.opacity = '0.5';
        }

        // Reset cursor and opacity for accessible steps
        if (stepNumber <= maxAccessibleStep) {
            btn.style.cursor = 'pointer';
            btn.style.opacity = '1';
        }
    });
}

function updateNavigationButtons() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    
    prevBtn.disabled = currentStep === 1;
    
    if (currentStep === totalSteps) {
        nextBtn.style.display = 'none';
    } else {
        nextBtn.style.display = 'block';
        nextBtn.textContent = 'Next';
    }
}

function getMaxAccessibleStep() {
    // Step 1 is always accessible
    let maxStep = 1;

    // Check if Step 1 is complete to allow Step 2
    if (validateStep1(true)) {
        maxStep = 2;

        // Check if Step 2 is complete to allow Step 3 (or Step 4 if step 3 is skipped)
        if (validateStep2(true)) {
            if (shouldSkipShareholdingStep()) {
                // Step 3 is skipped — jump straight to step 4 accessibility
                maxStep = 4;
            } else {
                maxStep = 3;

                // Check if Step 3 is complete to allow Step 4
                if (validateStep3(true)) {
                    maxStep = 4;
                }
            }
        }
    }

    return maxStep;
}

function validateCurrentStep() {
    switch (currentStep) {
        case 1:
            return validateStep1();
        case 2:
            return validateStep2();
        case 3:
            if (shouldSkipShareholdingStep()) return true;
            return validateStep3();
        case 4:
            return validateStep4();
        case 5:
            return validateStep5();
        case 6:
            return validateStep6();
        default:
            return true;
    }
}

function validateStep1(silent = false) {
    const proposedName = document.getElementById('proposedCompanyName');
    const numberOfDirectors = document.getElementById('numberOfDirectors');
    
    if (!proposedName.value.trim()) {
        if (!silent) {
            alert('Please enter the proposed company name.');
            proposedName.focus();
        }
        return false;
    }
    
    if (!numberOfDirectors.value) {
        if (!silent) {
            alert('Please select the number of directors.');
            numberOfDirectors.focus();
        }
        return false;
    }
    
    return true;
}

function validateStep2(silent = false) {
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    
    for (let i = 1; i <= numberOfDirectors; i++) {
        const requiredFields = [
            `director${i}FirstName`,
            `director${i}LastName`,
            `director${i}Email`,
            `director${i}Telephone`,
            `director${i}DateOfBirth`,
            `director${i}CityOfBirth`,
            `director${i}CountryOfBirth`,
            `director${i}TFN`
        ];
        
        for (const fieldId of requiredFields) {
            const field = document.getElementById(fieldId);
            if (!field || !field.value.trim()) {
                if (!silent) {
                    alert(`Please fill in all required fields for Director ${i}.`);
                    if (field) field.focus();
                }
                return false;
            }
        }
        
        // Check if shareholder selection is made
        const isShareholderYes = document.querySelector(`input[name="director${i}IsShareholder"][value="yes"]`);
        const isShareholderNo = document.querySelector(`input[name="director${i}IsShareholder"][value="no"]`);
        
        if (!isShareholderYes || !isShareholderNo || (!isShareholderYes.checked && !isShareholderNo.checked)) {
            if (!silent) {
                alert(`Please indicate whether Director ${i} will be a shareholder.`);
            }
            return false;
        }
        
        // Validate nominee individual fields if applicable
        if (isShareholderNo.checked) {
            const nomineeTypeSelect = document.getElementById(`director${i}NomineeType`);
            if (nomineeTypeSelect && nomineeTypeSelect.value === 'individual') {
                const nomineeIsDirector = document.getElementById(`director${i}NomineeIsDirector`);
                
                // Check if "Is nominee also director?" question is answered
                if (!nomineeIsDirector || !nomineeIsDirector.value) {
                    if (!silent) {
                        alert(`Please indicate whether the nominee individual for Director ${i} is also a director.`);
                        if (nomineeIsDirector) nomineeIsDirector.focus();
                    }
                    return false;
                }
                
                // If nominee is NOT a director, validate all nominee individual fields
                if (nomineeIsDirector.value === 'no') {
                    const nomineeRequiredFields = [
                        `director${i}NomineeFirstName`,
                        `director${i}NomineeLastName`,
                        `director${i}NomineeEmail`,
                        `director${i}NomineeTelephone`,
                        `director${i}NomineeDateOfBirth`,
                        `director${i}NomineeCityOfBirth`,
                        `director${i}NomineeCountryOfBirth`,
                        `director${i}NomineeTFN`,
                        `director${i}NomineeResidentialAddress`
                    ];
                    
                    for (const fieldId of nomineeRequiredFields) {
                        const field = document.getElementById(fieldId);
                        if (!field || !field.value.trim()) {
                            if (!silent) {
                                alert(`Please fill in all required nominee individual fields for Director ${i}.`);
                                if (field) field.focus();
                            }
                            return false;
                        }
                    }
                }
            }
            
            // Validate nominee company fields if applicable
            if (nomineeTypeSelect && nomineeTypeSelect.value === 'company') {
                const nomineeCompanyFields = [
                    `director${i}NomineeCompanyName`,
                    `director${i}NomineeCompanyACN`,
                    `director${i}NomineeCompanyAddress`,
                    `director${i}NomineeCompanyTFN`
                ];
                
                for (const fieldId of nomineeCompanyFields) {
                    const field = document.getElementById(fieldId);
                    if (!field || !field.value.trim()) {
                        if (!silent) {
                            alert(`Please fill in all required nominee company fields for Director ${i}.`);
                            if (field) field.focus();
                        }
                        return false;
                    }
                }
            }
            
            // Validate nominee trust fields if applicable
            if (nomineeTypeSelect && nomineeTypeSelect.value === 'trust') {
                const trustNameField = document.getElementById(`director${i}NomineeTrustName`);
                
                // Check if trust name is filled
                if (!trustNameField || !trustNameField.value.trim()) {
                    if (!silent) {
                        alert(`Please provide the trust name for Director ${i}.`);
                        if (trustNameField) trustNameField.focus();
                    }
                    return false;
                }
                
                const trusteeTypeSelect = document.getElementById(`director${i}NomineeTrusteeType`);
                
                // Check if trustee type is selected
                if (!trusteeTypeSelect || !trusteeTypeSelect.value) {
                    if (!silent) {
                        alert(`Please select the trustee type for Director ${i}.`);
                        if (trusteeTypeSelect) trusteeTypeSelect.focus();
                    }
                    return false;
                }
                
                // Validate individual trustee fields if selected
                if (trusteeTypeSelect.value === 'individual') {
                    const nomineeTrusteeFields = [
                        `director${i}NomineeTrusteeFirstName`,
                        `director${i}NomineeTrusteeLastName`,
                        `director${i}NomineeTrusteeEmail`,
                        `director${i}NomineeTrusteeTelephone`,
                        `director${i}NomineeTrusteeDateOfBirth`,
                        `director${i}NomineeTrusteeCityOfBirth`,
                        `director${i}NomineeTrusteeCountryOfBirth`,
                        `director${i}NomineeTrusteeTFN`,
                        `director${i}NomineeTrusteeResidentialAddress`
                    ];
                    
                    for (const fieldId of nomineeTrusteeFields) {
                        const field = document.getElementById(fieldId);
                        if (!field || !field.value.trim()) {
                            if (!silent) {
                                alert(`Please fill in all required nominee trust individual trustee fields for Director ${i}.`);
                                if (field) field.focus();
                            }
                            return false;
                        }
                    }
                } else if (trusteeTypeSelect.value === 'company') {
                    const nomineeTrusteeCompanyFields = [
                        `director${i}NomineeTrusteeCompanyName`,
                        `director${i}NomineeTrusteeCompanyACN`,
                        `director${i}NomineeTrusteeCompanyAddress`
                    ];
                    
                    for (const fieldId of nomineeTrusteeCompanyFields) {
                        const field = document.getElementById(fieldId);
                        if (!field || !field.value.trim()) {
                            if (!silent) {
                                alert(`Please fill in all required nominee trust company trustee fields for Director ${i}.`);
                                if (field) field.focus();
                            }
                            return false;
                        }
                    }
                }
            }
        }
    }
    
    return true;
}

function validateStep3(silent = false) {
    if (shouldSkipShareholdingStep()) return true;

    // Get the number of directors and check who are shareholders
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    const shareholderDirectors = [];
    
    for (let i = 1; i <= numberOfDirectors; i++) {
        const isShareholderYes = document.querySelector(`input[name="director${i}IsShareholder"][value="yes"]`);
        if (isShareholderYes && isShareholderYes.checked) {
            shareholderDirectors.push({ id: i });
        }
    }
    
    if (shareholderDirectors.length === 0) {
        if (!silent) {
            alert('At least one director must be a shareholder.');
        }
        return false;
    }
    
    // Validate share allocations for director shareholders
    for (const director of shareholderDirectors) {
        const sharesNumber = document.getElementById(`director${director.id}SharesNumber`);
        const shareValue = document.getElementById(`director${director.id}ShareValue`);
        
        if (!sharesNumber || !sharesNumber.value || parseInt(sharesNumber.value) < 1) {
            if (!silent) {
                alert(`Please specify the number of shares for ${getDirectorName(director.id)}.`);
                if (sharesNumber) sharesNumber.focus();
            }
            return false;
        }
        
        if (!shareValue || !shareValue.value || parseFloat(shareValue.value) < 0) {
            if (!silent) {
                alert(`Please specify the share value for ${getDirectorName(director.id)}.`);
                if (shareValue) shareValue.focus();
            }
            return false;
        }
    }
    
    return true;
}

function validateStep4(silent = false) {
    // Registration Details validation
    const industry = document.getElementById('industry');
    const businessActivity = document.getElementById('businessActivity');
    
    if (!industry || !industry.value.trim()) {
        if (!silent) {
            alert('Please enter the industry the new entity will operate in.');
            if (industry) industry.focus();
        }
        return false;
    }
    
    if (!businessActivity || !businessActivity.value.trim()) {
        if (!silent) {
            alert('Please enter your business activity.');
            if (businessActivity) businessActivity.focus();
        }
        return false;
    }
    
    return true;
}

function validateStep5(silent = false) {
    // Validate ASIC registered agent selection (required)
    const asicRegisteredAgent = document.getElementById('asicRegisteredAgent');
    if (!asicRegisteredAgent || !asicRegisteredAgent.value) {
        if (!silent) {
            alert('Please select whether you want to nominate Silver Peacock & Co as your ASIC registered agent.');
            if (asicRegisteredAgent) asicRegisteredAgent.focus();
        }
        return false;
    }
    
    return true;
}

function validateStep6(silent = false) {
    // Validate signature date
    const signatureDate = document.getElementById('signatureDate');
    if (!signatureDate || !signatureDate.value) {
        if (!silent) {
            alert('Please provide the date of signature.');
            if (signatureDate) signatureDate.focus();
        }
        return false;
    }
    
    // Validate signature location
    const signatureLocation = document.getElementById('signatureLocation');
    if (!signatureLocation || !signatureLocation.value.trim()) {
        if (!silent) {
            alert('Please provide the location of signature.');
            if (signatureLocation) signatureLocation.focus();
        }
        return false;
    }
    
    // Check if signature is provided using the new helper function
    if (isSignatureEmpty()) {
        if (!silent) {
            alert('Please provide your signature.');
        }
        return false;
    }
    
    // Update signature data before validation
    updateSignatureData();
    
    // Validate signature consent
    const signatureConsent = document.getElementById('signatureConsent');
    if (!signatureConsent || !signatureConsent.checked) {
        if (!silent) {
            alert('Please provide your consent for the digital signature.');
        }
        return false;
    }
    
    return true;
}

function populateReviewSection() {
    const reviewContent = document.getElementById('reviewContent');
    let html = '';
    
    // Company Details
    html += '<div class="bg-white p-4 rounded-lg border border-gray-200 mb-4">';
    html += '<h3 class="font-semibold text-gold-600 mb-3">Company Details</h3>';
    html += `<p><strong>Proposed Company Name:</strong> ${document.getElementById('proposedCompanyName').value}</p>`;
    html += `<p><strong>Number of Directors:</strong> ${document.getElementById('numberOfDirectors').value}</p>`;
    html += '</div>';
    
    // Directors Information
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    html += '<div class="bg-white p-4 rounded-lg border border-gray-200 mb-4">';
    html += '<h3 class="font-semibold text-gold-600 mb-3">Directors Information</h3>';
    
    for (let i = 1; i <= numberOfDirectors; i++) {
        html += `<div class="mb-4 p-3 bg-gray-50 rounded">`;
        html += `<h4 class="font-medium mb-2">Director ${i}</h4>`;
        html += `<p><strong>Name:</strong> ${document.getElementById(`director${i}FirstName`).value} ${document.getElementById(`director${i}MiddleName`).value} ${document.getElementById(`director${i}LastName`).value}</p>`;
        html += `<p><strong>Email:</strong> ${document.getElementById(`director${i}Email`).value}</p>`;
        html += `<p><strong>Telephone:</strong> ${document.getElementById(`director${i}Telephone`).value}</p>`;
        html += `<p><strong>Date of Birth:</strong> ${document.getElementById(`director${i}DateOfBirth`).value}</p>`;
        html += `<p><strong>Place of Birth:</strong> ${document.getElementById(`director${i}CityOfBirth`).value}, ${document.getElementById(`director${i}CountryOfBirth`).value}</p>`;
        
        const isShareholderYes = document.querySelector(`input[name="director${i}IsShareholder"][value="yes"]`);
        html += `<p><strong>Shareholder:</strong> ${isShareholderYes.checked ? 'Yes' : 'No'}</p>`;
        html += `</div>`;
    }
    html += '</div>';
    
    // Shareholding Structure
    html += '<div class="bg-white p-4 rounded-lg border border-gray-200 mb-4">';
    html += '<h3 class="font-semibold text-gold-600 mb-3">Shareholding Structure</h3>';
    
    if (shouldSkipShareholdingStep()) {
        html += '<p class="text-gray-500 italic">Not applicable — sole director is not a shareholder.</p>';
    } else {
        const shareholderDirectors = formData.directors.filter(director => director.isShareholder);
        if (shareholderDirectors.length > 0) {
            shareholderDirectors.forEach(director => {
                const directorName = getDirectorName(director.id);
                const shareClass = document.getElementById(`director${director.id}ShareClass`)?.value || 'ORD';
                const shareClassName = getShareClassName(shareClass);
                const sharesNumber = document.getElementById(`director${director.id}SharesNumber`).value;
                const shareValue = document.getElementById(`director${director.id}ShareValue`).value;
                const beneficiallyHeld = document.getElementById(`director${director.id}BeneficiallyHeld`).checked;

                html += `<div class="mb-3 bg-gray-50 p-3 rounded border border-gray-200">`;
                html += `<p class="font-medium text-gray-800">${directorName}</p>`;
                html += `<div class="text-sm text-gray-600 mt-1">`;
                html += `<p><strong>Share Class:</strong> ${shareClassName}</p>`;
                html += `<p><strong>Number of Shares:</strong> ${sharesNumber}</p>`;
                html += `<p><strong>Value per Share:</strong> $${parseFloat(shareValue).toFixed(2)}</p>`;
                html += `<p><strong>Total Value:</strong> $${(parseInt(sharesNumber) * parseFloat(shareValue)).toFixed(2)}</p>`;
                html += `<p><strong>Beneficially Held:</strong> ${beneficiallyHeld ? 'Yes' : 'No'}</p>`;
                html += `</div>`;
                html += `</div>`;
            });
        }
    }

    html += '</div>';
    
    // Registration Details
    html += '<div class="bg-white p-4 rounded-lg border border-gray-200 mb-4">';
    html += '<h3 class="font-semibold text-gold-600 mb-3">Registration Details</h3>';
    html += `<p><strong>Industry:</strong> ${document.getElementById('industry').value}</p>`;
    html += `<p><strong>Business Activity:</strong> ${document.getElementById('businessActivity').value}</p>`;
    
    // Registration requirements
    const abnReg = document.getElementById('abnRegistration').checked;
    const gstReg = document.getElementById('gstRegistration').checked;
    const paygReg = document.getElementById('paygRegistration').checked;
    
    if (abnReg || gstReg || paygReg) {
        html += '<p class="mt-3"><strong>Required Registrations:</strong></p>';
        html += '<ul class="list-disc list-inside ml-4">';
        if (abnReg) html += '<li>ABN registration required</li>';
        if (gstReg) html += '<li>GST Registration required</li>';
        if (paygReg) html += '<li>PAYG Withholding registration required</li>';
        html += '</ul>';
    } else {
        html += '<p class="mt-3"><strong>Required Registrations:</strong> None selected</p>';
    }
    
    html += '</div>';
    
    // Declarations and Nominations
    html += '<div class="bg-white p-4 rounded-lg border border-gray-200 mb-4">';
    html += '<h3 class="font-semibold text-gold-600 mb-3">Declarations and Nominations</h3>';
    
    const accountantNomination = document.getElementById('accountantNomination');
    const asicRegisteredAgent = document.getElementById('asicRegisteredAgent');
    
    html += `<p><strong>Accountant Nomination:</strong> ${accountantNomination.checked ? 'Yes - Silver Peacock & Co nominated as accountants and tax advisors' : 'No'}</p>`;
    html += `<p><strong>ASIC Registered Agent:</strong> ${asicRegisteredAgent.value ? (asicRegisteredAgent.value === 'yes' ? 'Yes - Silver Peacock & Co nominated as ASIC registered agent' : 'No') : 'Not selected'}</p>`;
    
    html += '</div>';
    
    reviewContent.innerHTML = html;
}

// Signature Canvas Functions
function initializeSignatureCanvas() {
    signatureCanvas = document.getElementById('signatureCanvas');
    if (!signatureCanvas) {
        console.warn('Signature canvas element not found');
        return;
    }

    try {
        signatureContext = signatureCanvas.getContext('2d', { willReadFrequently: true });
        if (!signatureContext) {
            console.warn('Failed to get 2D context for signature canvas');
            return;
        }

        // Set canvas size with validation
        const rect = signatureCanvas.getBoundingClientRect();
        const canvasWidth = rect.width || 400;
        const canvasHeight = rect.height || 150;

        // Enforce minimum dimensions
        if (canvasWidth < 200 || canvasHeight < 100) {
            console.warn('Canvas dimensions too small, using defaults');
            signatureCanvas.width = 400;
            signatureCanvas.height = 150;
        } else {
            signatureCanvas.width = canvasWidth;
            signatureCanvas.height = canvasHeight;
        }

        // Set drawing properties
        signatureContext.strokeStyle = '#000000';
        signatureContext.lineWidth = 2;
        signatureContext.lineCap = 'round';
        signatureContext.lineJoin = 'round';

        // Mouse events
        signatureCanvas.addEventListener('mousedown', startDrawing);
        signatureCanvas.addEventListener('mousemove', draw);
        signatureCanvas.addEventListener('mouseup', stopDrawing);
        signatureCanvas.addEventListener('mouseout', stopDrawing);

        // Touch events for mobile
        signatureCanvas.addEventListener('touchstart', handleTouch);
        signatureCanvas.addEventListener('touchmove', handleTouch);
        signatureCanvas.addEventListener('touchend', stopDrawing);

        // Clear signature button
        const clearButton = document.getElementById('clearSignature');
        if (clearButton) {
            clearButton.addEventListener('click', clearSignature);
        }

        // Window resize handler to preserve signature
        window.addEventListener('resize', handleCanvasResize);
    } catch (error) {
        console.error('Error initializing signature canvas:', error);
    }
}

function startDrawing(e) {
    if (!signatureCanvas || !signatureContext) return;
    
    isDrawing = true;
    const rect = signatureCanvas.getBoundingClientRect();
    const scaleX = signatureCanvas.width / rect.width;
    const scaleY = signatureCanvas.height / rect.height;
    const x = (e.clientX - rect.left) * scaleX;
    const y = (e.clientY - rect.top) * scaleY;
    
    signatureContext.beginPath();
    signatureContext.moveTo(x, y);
}

function draw(e) {
    if (!isDrawing || !signatureCanvas || !signatureContext) return;
    
    const rect = signatureCanvas.getBoundingClientRect();
    const scaleX = signatureCanvas.width / rect.width;
    const scaleY = signatureCanvas.height / rect.height;
    const x = (e.clientX - rect.left) * scaleX;
    const y = (e.clientY - rect.top) * scaleY;
    
    signatureContext.lineTo(x, y);
    signatureContext.stroke();
    
    // Save signature data
    updateSignatureData();
}

function stopDrawing() {
    if (!isDrawing) return;
    isDrawing = false;
    if (signatureContext) {
        signatureContext.beginPath();
    }
}

function handleTouch(e) {
    e.preventDefault();
    if (!e.touches || e.touches.length === 0) return;
    
    const touch = e.touches[0];
    const mouseEvent = new MouseEvent(
        e.type === 'touchstart' ? 'mousedown' : 
        e.type === 'touchmove' ? 'mousemove' : 'mouseup', 
        {
            clientX: touch.clientX,
            clientY: touch.clientY
        }
    );
    signatureCanvas.dispatchEvent(mouseEvent);
}

function clearSignature() {
    if (!signatureCanvas || !signatureContext) return;
    
    try {
        signatureContext.clearRect(0, 0, signatureCanvas.width, signatureCanvas.height);
        updateSignatureData();
    } catch (error) {
        console.warn('Error clearing signature:', error);
    }
}

function isSignatureEmpty() {
    if (!signatureCanvas || !signatureContext) return true;
    
    // Check if canvas has valid dimensions
    if (signatureCanvas.width === 0 || signatureCanvas.height === 0) {
        return true;
    }
    
    try {
        const imageData = signatureContext.getImageData(0, 0, signatureCanvas.width, signatureCanvas.height);
        return !imageData.data.some(channel => channel !== 0);
    } catch (error) {
        console.warn('Error checking signature canvas:', error);
        return true;
    }
}

function getSignatureDataURL() {
    if (!signatureCanvas) return null;
    
    // Check if canvas has valid dimensions
    if (signatureCanvas.width === 0 || signatureCanvas.height === 0) {
        return null;
    }
    
    if (isSignatureEmpty()) return null;
    
    try {
        return signatureCanvas.toDataURL('image/png', 1.0);
    } catch (error) {
        console.warn('Error getting signature data URL:', error);
        return null;
    }
}

function updateSignatureData() {
    const hiddenField = document.getElementById('signatureData');
    if (hiddenField) {
        const signatureData = getSignatureDataURL();
        hiddenField.value = signatureData || '';
    }
}

// Initialize signature date field with today's date
function initializeSignatureDate() {
    const signatureDateField = document.getElementById('signatureDate');
    if (signatureDateField) {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        signatureDateField.value = formattedDate;
    }
}

function handleCanvasResize() {
    if (!signatureCanvas || !signatureContext) return;
    
    try {
        // Save current signature
        const imageData = isSignatureEmpty() ? null : signatureContext.getImageData(0, 0, signatureCanvas.width, signatureCanvas.height);
        
        // Resize canvas
        const rect = signatureCanvas.getBoundingClientRect();
        const newWidth = rect.width || 400;
        const newHeight = rect.height || 150;
        
        if (newWidth >= 200 && newHeight >= 100) {
            signatureCanvas.width = newWidth;
            signatureCanvas.height = newHeight;
            
            // Restore drawing properties
            signatureContext.strokeStyle = '#000000';
            signatureContext.lineWidth = 2;
            signatureContext.lineCap = 'round';
            signatureContext.lineJoin = 'round';
            
            // Restore signature if it existed
            if (imageData) {
                signatureContext.putImageData(imageData, 0, 0);
            }
        }
    } catch (error) {
        console.warn('Error handling canvas resize:', error);
    }
}

// Form Submission
async function handleFormSubmission(e) {
    e.preventDefault();
    
    if (!validateCurrentStep()) {
        return;
    }
    
    // Get submit button reference
    const submitBtn = e.target.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    
    try {
        // Show loading state
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
        
        // Collect form data
        const formData = collectFormData();
        
        // Submit to webhook
        const response = await fetch('/Forms/CompanyRegistrationWebhookProxy', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        
        const result = await response.json();
        
        if (result.success) {
            // Redirect to thank you page using the URL from the server response
            if (result.redirectUrl) {
                window.location.href = result.redirectUrl;
            } else {
                // Fallback redirect if redirectUrl is not provided
                window.location.href = `/Forms/CompanyRegistrationThankYou?submissionId=${result.submissionId || Date.now()}&clientName=${encodeURIComponent(formData.proposedCompanyName || 'Valued Client')}`;
            }
        } else {
            throw new Error(result.error || 'Submission failed');
        }
        
    } catch (error) {
        alert('There was an error submitting your form. Please try again.');
        console.error('Form submission error:', error);
        
        // Restore button state
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
    }
}

function collectFormData() {
    const data = {
        form_type: 'Company Registration',
        submission_date: new Date().toISOString(),
        
        // Company details
        proposedCompanyName: document.getElementById('proposedCompanyName').value,
        numberOfDirectors: parseInt(document.getElementById('numberOfDirectors').value),
        
        // Directors data
        directors: [],
        
        // Shareholding data
        shareholding: [],
        
        // Trust data (if applicable)
        trustDetails: null,
        
        // Signature
        signatureDate: document.getElementById('signatureDate').value,
        signatureLocation: document.getElementById('signatureLocation').value,
        signatureData: document.getElementById('signatureData').value,
        signatureConsent: document.getElementById('signatureConsent').checked,
        
        // Anti-spam
        form_load_time: document.getElementById('form_load_time').value,
        website_url: document.getElementById('website_url').value
    };
    
    // Collect directors data
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    for (let i = 1; i <= numberOfDirectors; i++) {
        const director = {
            directorNumber: i,
            firstName: document.getElementById(`director${i}FirstName`).value,
            middleName: document.getElementById(`director${i}MiddleName`).value,
            lastName: document.getElementById(`director${i}LastName`).value,
            email: document.getElementById(`director${i}Email`).value,
            telephone: document.getElementById(`director${i}Telephone`).value,
            dateOfBirth: document.getElementById(`director${i}DateOfBirth`).value,
            cityOfBirth: document.getElementById(`director${i}CityOfBirth`).value,
            countryOfBirth: document.getElementById(`director${i}CountryOfBirth`).value,
            tfn: document.getElementById(`director${i}TFN`).value,
            din: document.getElementById(`director${i}DIN`).value,
            isShareholder: document.querySelector(`input[name="director${i}IsShareholder"]:checked`)?.value === 'yes',
            nomineeConsent: document.getElementById(`director${i}Nominee`)?.checked || false,
            nomineeType: document.getElementById(`director${i}NomineeType`)?.value || null
        };
        
        // Collect nominee individual details if applicable
        if (director.nomineeType === 'individual') {
            const nomineeIsDirector = document.getElementById(`director${i}NomineeIsDirector`)?.value;
            director.nomineeIndividual = {
                isAlsoDirector: nomineeIsDirector === 'yes'
            };
            
            // Only collect details if nominee is NOT also a director
            if (nomineeIsDirector === 'no') {
                director.nomineeIndividual.details = {
                    firstName: document.getElementById(`director${i}NomineeFirstName`)?.value || '',
                    middleName: document.getElementById(`director${i}NomineeMiddleName`)?.value || '',
                    lastName: document.getElementById(`director${i}NomineeLastName`)?.value || '',
                    email: document.getElementById(`director${i}NomineeEmail`)?.value || '',
                    telephone: document.getElementById(`director${i}NomineeTelephone`)?.value || '',
                    dateOfBirth: document.getElementById(`director${i}NomineeDateOfBirth`)?.value || '',
                    cityOfBirth: document.getElementById(`director${i}NomineeCityOfBirth`)?.value || '',
                    countryOfBirth: document.getElementById(`director${i}NomineeCountryOfBirth`)?.value || '',
                    tfn: document.getElementById(`director${i}NomineeTFN`)?.value || '',
                    residentialAddress: document.getElementById(`director${i}NomineeResidentialAddress`)?.value || ''
                };
            }
        }
        
        // Collect nominee company details if applicable
        if (director.nomineeType === 'company') {
            director.nomineeCompany = {
                companyName: document.getElementById(`director${i}NomineeCompanyName`)?.value || '',
                acn: document.getElementById(`director${i}NomineeCompanyACN`)?.value || '',
                registeredAddress: document.getElementById(`director${i}NomineeCompanyAddress`)?.value || '',
                tfn: document.getElementById(`director${i}NomineeCompanyTFN`)?.value || ''
            };
        }
        
        // Collect nominee trust details if applicable
        if (director.nomineeType === 'trust') {
            const trusteeType = document.getElementById(`director${i}NomineeTrusteeType`)?.value;
            director.nomineeTrust = {
                trustName: document.getElementById(`director${i}NomineeTrustName`)?.value || '',
                trusteeType: trusteeType
            };
            
            if (trusteeType === 'individual') {
                director.nomineeTrust.individualTrustee = {
                    firstName: document.getElementById(`director${i}NomineeTrusteeFirstName`)?.value || '',
                    middleName: document.getElementById(`director${i}NomineeTrusteeMiddleName`)?.value || '',
                    lastName: document.getElementById(`director${i}NomineeTrusteeLastName`)?.value || '',
                    email: document.getElementById(`director${i}NomineeTrusteeEmail`)?.value || '',
                    telephone: document.getElementById(`director${i}NomineeTrusteeTelephone`)?.value || '',
                    dateOfBirth: document.getElementById(`director${i}NomineeTrusteeDateOfBirth`)?.value || '',
                    cityOfBirth: document.getElementById(`director${i}NomineeTrusteeCityOfBirth`)?.value || '',
                    countryOfBirth: document.getElementById(`director${i}NomineeTrusteeCountryOfBirth`)?.value || '',
                    tfn: document.getElementById(`director${i}NomineeTrusteeTFN`)?.value || '',
                    residentialAddress: document.getElementById(`director${i}NomineeTrusteeResidentialAddress`)?.value || ''
                };
            } else if (trusteeType === 'company') {
                director.nomineeTrust.companyTrustee = {
                    companyName: document.getElementById(`director${i}NomineeTrusteeCompanyName`)?.value || '',
                    acn: document.getElementById(`director${i}NomineeTrusteeCompanyACN`)?.value || '',
                    registeredAddress: document.getElementById(`director${i}NomineeTrusteeCompanyAddress`)?.value || ''
                };
            }
        }
        
        // Add shareholding details if director is a shareholder
        if (director.isShareholder) {
            director.shareDetails = {
                shareClass: document.getElementById(`director${i}ShareClass`).value,
                numberOfShares: document.getElementById(`director${i}SharesNumber`).value,
                valuePerShare: document.getElementById(`director${i}ShareValue`).value,
                beneficiallyHeld: document.getElementById(`director${i}BeneficiallyHeld`).checked
            };
            
            data.shareholding.push({
                shareholderType: 'director',
                directorNumber: i,
                directorName: `${director.firstName} ${director.lastName}`,
                shareClass: director.shareDetails.shareClass,
                shareClassName: getShareClassName(director.shareDetails.shareClass),
                ...director.shareDetails
            });
        }
        
        data.directors.push(director);
    }
    
    // Collect registration details
    data.registrationDetails = {
        industry: document.getElementById('industry').value,
        businessActivity: document.getElementById('businessActivity').value,
        abnRegistration: document.getElementById('abnRegistration').checked,
        gstRegistration: document.getElementById('gstRegistration').checked,
        paygRegistration: document.getElementById('paygRegistration').checked
    };
    
    // Collect declarations and nominations
    data.accountantNomination = document.getElementById('accountantNomination').checked;
    data.asicRegisteredAgent = document.getElementById('asicRegisteredAgent').value;
    
    return data;
}

// Balloon popup functionality
function initializeBalloonPopups() {
    // Initialize any existing popups when page loads
    setTimeout(() => {
        setupDynamicBalloonPopups();
    }, 100);
    
    // Set up event delegation for dynamically created popups
    document.addEventListener('click', function(e) {
        const icon = e.target.closest('.dependents-info-icon');
        if (icon) {
            e.preventDefault();
            e.stopPropagation();
            
            const popupId = icon.getAttribute('data-popup-target');
            if (popupId) {
                const popup = document.getElementById(popupId);
                if (popup) {
                    if (window.innerWidth < 1025) { // Mobile/Tablet
                        if (popup.style.display === 'block') {
                            hideBalloonPopup(popup);
                        } else {
                            // Hide any other open popups first
                            hideAllBalloonPopups();
                            showBalloonPopup(popup);
                        }
                    }
                }
            }
        }
    });
    
    // Set up hover events for desktop
    document.addEventListener('mouseenter', function(e) {
        if (e.target && e.target.closest) {
            const icon = e.target.closest('.dependents-info-icon');
            if (icon && window.innerWidth >= 1025) { // Desktop
                const popupId = icon.getAttribute('data-popup-target');
                if (popupId) {
                    const popup = document.getElementById(popupId);
                    if (popup) {
                        clearTimeout(popup.hoverTimeout);
                        showBalloonPopup(popup);
                    }
                }
            }
        }
    }, true);
    
    document.addEventListener('mouseleave', function(e) {
        if (e.target && e.target.closest) {
            const icon = e.target.closest('.dependents-info-icon');
            if (icon && window.innerWidth >= 1025) { // Desktop
                const popupId = icon.getAttribute('data-popup-target');
                if (popupId) {
                    const popup = document.getElementById(popupId);
                    if (popup) {
                        popup.hoverTimeout = setTimeout(() => {
                            hideBalloonPopup(popup);
                        }, 200);
                    }
                }
            }
        }
    }, true);
    
    // Keep popup open when hovering over it (desktop)
    document.addEventListener('mouseenter', function(e) {
        if (e.target && e.target.closest) {
            const popup = e.target.closest('.dependents-popup');
            if (popup && window.innerWidth >= 1025) { // Desktop
                clearTimeout(popup.hoverTimeout);
            }
        }
    }, true);
    
    document.addEventListener('mouseleave', function(e) {
        if (e.target && e.target.closest) {
            const popup = e.target.closest('.dependents-popup');
            if (popup && window.innerWidth >= 1025) { // Desktop
                popup.hoverTimeout = setTimeout(() => {
                    hideBalloonPopup(popup);
                }, 200);
            }
        }
    }, true);
    
    // Hide popups when clicking outside (mobile/tablet)
    document.addEventListener('click', function(e) {
        if (window.innerWidth < 1025) { // Mobile/Tablet
            const isPopupClick = e.target.closest('.dependents-popup');
            const isIconClick = e.target.closest('.dependents-info-icon');
            
            if (!isPopupClick && !isIconClick) {
                hideAllBalloonPopups();
            }
        }
    });
    
    // Handle mobile close button (pseudo-element click)
    document.addEventListener('click', function(e) {
        const popup = e.target.closest('.dependents-popup');
        if (popup && window.innerWidth < 1025) { // Mobile/Tablet
            const rect = popup.getBoundingClientRect();
            const isCloseButton = e.clientX > rect.right - 40 && 
                                e.clientY < rect.top + 40;
            
            if (isCloseButton) {
                e.stopPropagation();
                hideBalloonPopup(popup);
            }
        }
    });
    
    // Hide popups on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            hideAllBalloonPopups();
        }
    });
    
    // Handle window resize
    window.addEventListener('resize', function() {
        // Hide all popups when switching between desktop and mobile
        hideAllBalloonPopups();
    });
}

function setupDynamicBalloonPopups() {
    // This function can be called whenever new dynamic content is added
    // to ensure balloon popups work on newly created elements
    document.querySelectorAll('.dependents-info-icon').forEach(icon => {
        // Event listeners are handled through delegation above
    });
}

function showBalloonPopup(popup) {
    popup.style.display = 'block';
    popup.style.opacity = '0';
    
    // Force reflow
    popup.offsetHeight;
    
    // Animate in
    popup.style.transition = 'opacity 0.3s ease-in-out';
    popup.style.opacity = '1';
}

function hideBalloonPopup(popup) {
    popup.style.transition = 'opacity 0.3s ease-in-out';
    popup.style.opacity = '0';
    
    setTimeout(() => {
        popup.style.display = 'none';
    }, 300);
}

function hideAllBalloonPopups() {
    document.querySelectorAll('.dependents-popup').forEach(popup => {
        hideBalloonPopup(popup);
    });
}

// Make functions available globally for inline onclick handlers
window.changeStep = changeStep;
window.goToStep = goToStep;
window.handleShareholderChange = handleShareholderChange;
window.handleNomineeTypeChange = handleNomineeTypeChange;
window.handleNomineeIsDirectorChange = handleNomineeIsDirectorChange;
window.handleNomineeTrusteeTypeChange = handleNomineeTrusteeTypeChange;
